import Large from './Large';
import Regular from './Regular';
import Small from './Small';
import Action from './Action';
import BodyBase from './BodyBase';
import BodySmall from './BodySmall';
import BodyExtraSmall from './BodyExtraSmall';

export default {
  BodyBase,
  BodySmall,
  BodyExtraSmall,
  /** @deprecated use Text.BodyBase */
  Large,
  /** @deprecated use Text.BodySmall */
  Regular,
  /** @deprecated use Text.BodyExtraSmall */
  Small,
  Action,
};

export const TextBodyBase = BodyBase;
export const TextBodySmall = BodySmall;
export const TextBodyExtraSmall = BodyExtraSmall;

/** @deprecated use TextBodyBase */
export const TextLarge = Large;
/** @deprecated use TextBodySmall */
export const TextRegular = Regular;
/** @deprecated use TextBodyExtraSmall */
export const TextSmall = Small;
/** @deprecated use TextBodySmall */
export const Text = Regular;
